import pdfMake from 'pdfmake/build/pdfmake'
import JsBarcode from 'jsbarcode'
import { logo2Img } from '../../../../services/others/assets'

/**
 * Packing Slip PDF Generator - With Price
 * 含价格版本
 */
export default async (data: any, require?: string, getBlob?: any, filename?: string) => {
  const orderNo = data.packingSlipNo
  const deliveredAt = data.deliveredAt
  const deliveryName = data.customer.deliveryName
  const outstanding = data.outstanding
  const comments = !data.customer.warehouseNote ? '' : data.customer.warehouseNote
  const vfsFonts = await import("pdfmake/build/vfs_fonts")

  pdfMake.fonts = {
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-MediumItalic.ttf'
    },
    weiruanyahei: {
      normal: '微软雅黑.ttf',
      bold: '微软雅黑.ttf',
      italics: '微软雅黑.ttf',
      bolditalics: '微软雅黑.ttf'
    }
  }
  const { vfs } = vfsFonts.pdfMake
  pdfMake.vfs = vfs

  const tableWidthWithPrice = [90, '*', 45, 45, 45, 45]
  const contents = table(data)
  const content2 = tableOutstanding(data)
  const priceSummary = calculatePriceSummary(data)

  const formatDate = (date: string) => {
    if (!date) return ''

    let utcDate = date.replace(' ', 'T')
    if (!utcDate.endsWith('Z')) {
      utcDate = utcDate + 'Z'
    }

    const dateObj = new Date(utcDate)
    const formatter = new Intl.DateTimeFormat('en-NZ', {
      timeZone: 'Pacific/Auckland',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    })

    const parts = formatter.formatToParts(dateObj)
    const day = parts.find(p => p.type === 'day')?.value
    const month = parts.find(p => p.type === 'month')?.value
    const year = parts.find(p => p.type === 'year')?.value

    return `${day}/${month}/${year}`
  }

  const getCurDate = () => {
    const da = new Date()
    var year = da.getFullYear()
    var month = da.getMonth() + 1
    var date = da.getDate()
    return date + '/' + month + '/' + year
  }

  const getNumber = (data: any) => {
    let ret
    const mobile = data?.customer?.customer?.mobile
    const phone = data?.customer?.customer?.phone
    if (mobile && !phone)
      ret = mobile
    else if (phone && !mobile)
      ret = phone
    else if (phone && mobile)
      ret = mobile + "," + phone
    else
      ret = ""
    return ret
  }

  const formatAddress = (address: string) => {
    if (!address) return ' '
    return address.replace(/,/g, ',\n')
  }

  const getLine = (data: any) => {
    // if (!data || data.length == 0) return "\n\n\n"
    // if (data.length <= 160) return data + "\n\n\n"
    // if (data.length <= 320) return data + "\n\n"
    return data + "\n"
  }

  const textToBase64Barcode = (text: string) => {
    const canvas = document.createElement('canvas')
    JsBarcode(canvas, text, { displayValue: false })
    return canvas.toDataURL('image/png')
  }

  const documentDefinition: any = {
    pageSize: 'A4',
    pageOrientation: 'landscape',
    pageMargins: [15, 20, 30, 130],
    info: {
      title: 'PackingSlip: ' + data.packingSlipNo,
      author: 'Jadcup',
      subject: 'PackingSlip: ' + data.packingSlipNo,
      keywords: 'Jadcup',
    },
    content: [
      {
        fontSize: 10,
        table: {
          headerRows: 1,
          widths: ['*'],
          heights: [80, 100, 'auto', 70, 80],
          layout: 'noBorders',
          body: [
            // Header Row One
            [
              {
                columns: [
                  // Left half: Logo + PRICED PACKING SLIP
                  {
                    width: '50%',
                    margin: [15, 0, 0, 0],
                    columns: [
                      {
                        image: logo2Img,
                        width: 80,
                        height: 84,
                        margin: [0, -15, 0, 0]
                      },
                      {
                        width: '*',
                        margin: [40, 15, 0, 0],
                        text: 'PRICED PACKING SLIP',
                        bold: true,
                        fontSize: 20,
                        color: 'black'
                      }
                    ]
                  },
                  // Right half: Details + Barcode
                  {
                    width: '50%',
                    margin: [0, 5, 10, 0],
                    columns: [
                      // First column: Details (top, middle, bottom)
                      {
                        width: '*',
                        type: 'none',
                        ul: [
                          { text: 'Packing Slip No: ' + orderNo, fontSize: 11, margin: [0, 0, 0, 2] },
                          { text: 'Delivery Date: ' + (deliveredAt ? formatDate(deliveredAt) : getCurDate()), fontSize: 11, margin: [0, 0, 0, 2] },
                          { text: 'Purchase Order No: ' + (data.customer.custOrderNo || ''), fontSize: 11, margin: [0, 0, 0, 0] },
                        ]
                      },
                      // Second column: Barcode
                      {
                        image: textToBase64Barcode(orderNo),
                        width: 180,
                        height: 48,
                        margin: [10, 0, 0, 0]
                      }
                    ]
                  }
                ]
              }
            ],
            // Second Header Row
            [
              {
                margin: [0, -20, 0, 0],
                table: {
                  widths: ['33.2%', '0.02%', '33.2%', '0.02%', '33.2%'],
                  body: [
                    // Header row
                    [
                      { text: 'Supplier Name', alignment: 'left', fontSize: 11, bold: true, border: [true, true, true, true], color: "white", fillColor: '#12231a', margin: [0, 3, 0, 3] },
                      { text: '', border: [false, false, false, false], fillColor: 'white' },
                      { text: 'Bill To', alignment: 'left', fontSize: 11, bold: true, border: [true, true, true, true], color: "white", fillColor: '#12231a', margin: [0, 3, 0, 3] },
                      { text: '', border: [false, false, false, false], fillColor: 'white' },
                      { text: 'Ship To', alignment: 'left', fontSize: 11, bold: true, border: [true, true, true, true], color: "white", fillColor: '#12231a', margin: [0, 3, 0, 3] },
                    ],
                    // Content row (按实际内容)
                    [
                      { text: 'Jadcup\n17b Landing Drive,\nMangere, Auckland', alignment: 'left', fontSize: 10, border: [true, false, true, true] },
                      { text: '', border: [false, false, false, false], fillColor: 'white' },
                      { text: (data.customer.customer.company || ' ') + '\n' + formatAddress(data.customer.customer.address1), alignment: 'left', fontSize: 10, border: [true, false, true, true] },
                      { text: '', border: [false, false, false, false], fillColor: 'white' },
                      { text: `${deliveryName ? deliveryName : data.customer.customer.customerCode ? data.customer.customer.customerCode : ' '}\n` +
                        `${data.customer.deliveryAddress ? data.customer.deliveryAddress : ' '}`.replace(/,/, '').replace(/,/g, ',\n'), alignment: 'left', fontSize: 10, border: [true, false, true, true] },
                    ],
                  ]
                }
              }
            ],
            [
              {
                margin: [0, -34, 3, 0],
                layout: 'noBorders',
                fontSize: 8,
                table: {
                  widths: ['*'],
                  body: [
                    [
                      {
                        margin: [3, 3, 3, 5],
                        fontSize: 8,
                        fillColor: '#12231a',
                        table: {
                          widths: tableWidthWithPrice,
                          body: [
                            [
                              { text: 'Product Code', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a', alignment: 'left' },
                              { text: 'Product Description', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a', alignment: 'left' },
                              { text: 'Quantity', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a', alignment: 'right' },
                              { text: 'Unit', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a', alignment: 'right' },
                              { text: 'Unit Price', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a', alignment: 'right' },
                              { text: 'Amount', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a', alignment: 'right' },
                            ],
                          ],
                        },
                        layout: 'headerLineOnly',
                      }
                    ],
                    [
                      {
                        margin: [3, 0, 0, 0],
                        fontSize: 8,
                        lineHeight: 1.1,
                        table: {
                          widths: tableWidthWithPrice,
                          body: [
                            ...contents,
                          ],
                        },
                        layout: 'headerLineOnly',
                      }
                    ]
                  ]
                }
              }
            ],
            // Price Summary Section
            [
              {
                margin: [0, -5, 3, 0],
                columns: [
                  { width: '*', text: '' },
                  {
                    width: 180,
                    layout: 'noBorders',
                    table: {
                      widths: ['*', 80],
                      body: [
                        [
                          { text: 'Subtotal', bold: true, fontSize: 10, alignment: 'right' },
                          { text: '$' + (priceSummary?.subtotal || '0.00'), fontSize: 10, alignment: 'right' },
                        ],
                        [
                          { text: 'Total GST 15%', bold: true, fontSize: 10, alignment: 'right', border: [false, false, false, true], borderColor: ['#080000', '#999', '#999', '#050505'] },
                          { text: '$' + (priceSummary?.gst || '0.00'), fontSize: 10, alignment: 'right', border: [false, false, false, true], borderColor: ['#999', '#999', '#999', '#999'] },
                        ],
                        [
                          { text: '_____________________', bold: true, fontSize: 10, alignment: 'right', margin: [0, -10, -10, 0] },
                          { text: '____________________', bold: true, fontSize: 10, alignment: 'left', margin: [-10, -10, 0, 0] },
                        ],
                        [
                          { text: 'Total NZD', bold: true, fontSize: 11, alignment: 'right', margin: [0, 0, 0, 0] },
                          { text: '$' + (priceSummary?.total || '0.00'), fontSize: 11, bold: true, alignment: 'right', margin: [0, 0, 0, 0] },
                        ],
                      ],
                    },
                  },
                ],
              }
            ],
            [
              content2.length <= 0 ? null : {
                margin: [0, 0, 0, 0],
                style: 'tableExample',
                fontSize: 8,
                lineHeight: 1.3,
                table: {
                  widths: ['*'],
                  body: [
                    [
                      content2.length <= 0 ? null : {
                        margin: [0, 0, 0, 0],
                        columns: [
                          {
                            type: 'none',
                            ul: [
                              { text: "***The following table shows an outstanding item in backorder for this Purchase Order: " + (data.customer.custOrderNo || ''), bold: true, fontSize: 10 },
                            ],
                          }
                        ]
                      }
                    ],
                    [
                      content2.length <= 0 ? null : {
                        margin: [0, 0, 0, 0],
                        style: 'tableExample',
                        fontSize: 8,
                        fillColor: '#12231a',
                        table: {
                          widths: tableWidthWithPrice,
                          body: [
                            [
                              { text: 'Product Code', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a', alignment: 'left' },
                              { text: 'Product Description', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a', alignment: 'left' },
                              { text: 'Quantity', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a', alignment: 'right' },
                              { text: 'Unit', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a', alignment: 'right' },
                              { text: 'Unit Price', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a', alignment: 'right' },
                              { text: 'Amount', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a', alignment: 'right' },
                            ],
                          ],
                        },
                        layout: 'headerLineOnly',
                      }
                    ],
                    [
                      content2.length <= 0 ? null : {
                        margin: [0, 0, 0, 0],
                        style: 'tableExample',
                        fontSize: 8,
                        lineHeight: 1.1,
                        table: {
                          widths: tableWidthWithPrice,
                          body: [
                            ...content2,
                          ],
                        },
                        layout: 'headerLineOnly',
                      }
                    ],
                  ],
                  border: [true, true, true, true]
                }
              }
            ],
          ]
        },
        layout: 'noBorders',
        margin: [0, 0, 0, 120]
      },
    ],
    defaultStyle: {
      font: 'Roboto',
    },
    footer: function () {
      return [
        {
          margin: [15, -30, 30, -80],
          fontSize: 10,
          columns: [
            {
              table: {
                headerRows: 1,
                widths: ['*'],
                body: [
                  [{ text: 'Delivery & Acceptance:\n', fontSize: 10, bold: true, border: [false, false, false, false] }],
                  [
                    {
                      columns: [
                        {
                          width: '*',
                          stack: [
                            { text: '* Please verify all products and quantities upon receipt. Any discrepancies must be reported within 48 hours of delivery.', fontSize: 9, border: [false, false, false, false] },
                            { text: "* Returns require prior written approval and must be returned in original condition and packaging.", fontSize: 9, border: [false, false, false, false] },
                            { text: "* Return freight is the responsibility of the customer unless due to supplier error.", fontSize: 9, border: [false, false, false, false] }
                          ]
                        },
                        {
                          width: 250,
                          stack: [
                            { text: '  ', bold: true, fontSize: 9, border: [false, false, false, false], margin: [5, 0, 0, 3] },
                            { text: '  ', bold: true, fontSize: 9, border: [false, false, false, false], margin: [5, 0, 0, 3] },
                            { text: 'Sign: ________________________ Date: ___________________', bold: true, fontSize: 9, border: [false, false, false, false], margin: [0, -5, 0, 0] }
                          ]
                        }
                      ],
                      border: [false, false, false, false]
                    }
                  ],

                  [{ text: 'Delivery Information: ' , border: [true, true, true, true], bold: true, color: 'white', fillColor: '#12231a', lineHeight: 1.3 }],
                  [{ text: 'Delivery By: ' + ((data?.courier) ? data.courier : " "), border: [true, true, true, false], lineHeight: 1 }],
                  [{ text: getLine(comments), border: [true, false, true, true], lineHeight: 1 }],
                ]
              }
            }
          ]
        },
        {
          margin: [0, 85, 0, 0],
          columns: [
            [
              { text: 'Operation hours: 8:30 am - 5:00 pm, Monday to Friday', alignment: 'center', lineHeight: 1.3, bold: true, fontSize: 9 },
              { text: 'Customer Service: 092823988 / Email: order@jadcup.co.nz / Address: 17b Landing Drive, Mangere, Auckland', alignment: 'center', lineHeight: 1.3, bold: true, fontSize: 8 },
            ]
          ],
        },
      ]
    },
    pageBreakBefore: function (currentNode: any, followingNodesOnPage: any, nodesOnNextPage: any, previousNodesOnPage: any) {
      return currentNode.headlineLevel === 'Conditions' && currentNode.startPosition.top > 720
    },
  }

  if (require === "getBlob") {
    const pdfDocGenerator = pdfMake.createPdf(documentDefinition)
    pdfDocGenerator.getBlob((blob) => {
      console.log(blob, 'blob')
      getBlob(filename, blob)
    })
  }
  else
    pdfMake.createPdf(documentDefinition).open()
}

// Helper functions
const getProdPkgById = (data: any, id: string) => {
  let orderProduct = data.customer.orderProduct || []
  let pkg = orderProduct
    .filter((e: any) => e.productId === id)
    .map((e: any) => e.product?.baseProduct?.packagingType?.quantity)[0]

  return pkg || 1
}

const getProdUnitPriceById = (data: any, id: string) => {
  let orderProduct = data.customer.orderProduct || []
  let unitPrice = orderProduct
    .filter((e: any) => e.productId === id)
    .map((e: any) => e.unitPrice)[0]

  return unitPrice || 0
}

const getProdUnit = (data: any, id: string) => {
  let orderProduct = data.customer.orderProduct || []
  let unit = orderProduct
    .filter((e: any) => e.productId === id)
    .map((e: any) => e.product?.baseProduct?.packagingType?.packagingCategory || 'PCS')[0]
  return unit || 'PCS'
}

const getProdPriceById = (data: any, id: string, qty: number) => {
  let unitPrice = getProdUnitPriceById(data, id)
  let pkg = getProdPkgById(data, id)
  let price = ((qty * unitPrice) / pkg).toFixed(2)
  return price
}

const table = (data: any) => {
  let mainData = data.tableContent.map((res: any) => {
    return [
      { text: res.product?.replace(/\u2011/g, '-'), alignment: 'left' },
      { text: res.description?.replace(/\u2011/g, '-') + '/' + getProdPkgById(data, res.productId) + '\n', alignment: 'left' },
      { text: res.carton, alignment: 'right' },
      { text: getProdUnit(data, res.productId), alignment: 'right' },
      { text: "$" + getProdUnitPriceById(data, res.productId).toFixed(2), alignment: 'right' },
      { text: "$" + getProdPriceById(data, res.productId, res.quantity), alignment: 'right' },
    ]
  })
  if (data.palletType)
    mainData.push([{ text: '', alignment: 'right' }, { text: changePalletName(data.palletType), alignment: 'right' }, { text: '', alignment: 'right' }, { text: '', alignment: 'right' }, { text: '', alignment: 'right' }, { text: '', alignment: 'right' }])
  return mainData
}

const changePalletName = (str: any) => {
  let start = str.indexOf("(")
  return str.substr(0, start) + " Pallet"
}

/**
 * 根据箱数判断是否还有 back order
 * 如果订单箱数 > 已送货箱数，则该产品在 back order 中
 */
const tableOutstanding = (data: any) => {
  const outstanding = data.outstanding || []
  return outstanding
    .filter((res: any) => {
      const packagingQuantity = res.product.baseProduct.packagingType.quantity;
      // 订单箱数 = 向上取整(订单数量 / 每箱数量)
      const orderBoxes = Math.ceil(res.quantity / packagingQuantity);
      // 已送货箱数 = 向上取整(已送货数量 / 每箱数量)
      const deliveredBoxes = Math.ceil(res.dispatchedQuantity / packagingQuantity);
      // 如果订单箱数 > 已送货箱数，则该产品在 back order 中
      return orderBoxes > deliveredBoxes;
    })
    .map((res: any) => {
      const outstandingQty = res.quantity - res.dispatchedQuantity
      // Get packaging info from the enriched orderProduct
      const orderProduct = data.customer?.orderProduct || []
      const matchedProduct = orderProduct.find((e: any) => e.productId === res.product.productId)
      const pkg = matchedProduct?.product?.baseProduct?.packagingType?.quantity || 1
      const unit = matchedProduct?.product?.baseProduct?.packagingType?.packagingCategory || 'Carton'
      const unitPrice = matchedProduct?.unitPrice || 0
      const amount = ((outstandingQty * unitPrice) / pkg).toFixed(2)

      return [
        { text: res.product.productCode?.replace(/\u2011/g, '-'), alignment: 'left' },
        { text: res.product.productName?.replace(/\u2011/g, '-') + '/' + pkg + '\n', alignment: 'left' },
        { text: outstandingQty, alignment: 'right' },
        { text: unit, alignment: 'right' },
        { text: "$" + unitPrice.toFixed(2), alignment: 'right' },
        { text: "$" + amount, alignment: 'right' },
      ]
    })
}

// Calculate price summary
const calculatePriceSummary = (data: any) => {
  let subtotal = 0
  data.tableContent.forEach((res: any) => {
    const price = parseFloat(getProdPriceById(data, res.productId, res.quantity))
    subtotal += price
  })

  const gst = subtotal * 0.15
  const total = subtotal + gst

  return {
    subtotal: subtotal.toFixed(2),
    gst: gst.toFixed(2),
    total: total.toFixed(2)
  }
}
